var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.8 35.1",
    style: {
      enableBackground: "new 0 0 33.8 35.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,3.8H23c-0.4,0-0.7,0.2-0.9,0.5c-0.4,0.7,0.1,1.4,0.8,1.4h4.6L19.2,14c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0   l8.3-8.3v4.6c0,0.5,0.4,0.9,1,1c0.5,0,1-0.5,1-1V4.8C30.9,4.3,30.4,3.8,29.9,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,27.9c0,0.6-0.5,1-1,1H6.7c-0.6,0-1-0.5-1-1v-16c0-0.6,0.5-1,1-1h12.9l2.1-2.1h-15C5,8.8,3.5,10.2,3.5,12   v16.1c0,1.7,1.4,3.2,3.2,3.2h16.1c1.7,0,3.2-1.4,3.2-3.2V13l-2.1,2.1v12.8H23.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.069c6450072b70fa4e9d8df1f333c34d.svg";
export { ForwardRef as ReactComponent };